
import { Grid, Card, CardContent, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { CustomTabs, Alert } from 'frame/components'
import { constants } from '../module'
import { useLocation } from 'react-router-dom'
import AddEditFbtRoutes from './routes'

const Form = () => {
  const location = useLocation()

  const fbtWebForm = useSelector(state => state?.fbtSubmissions?.fbtWebForm)

  const tabsConfig = [
    {
      label: 'Add/Edit Submission',
      path: `${location.pathname.replace(/\/[^/]*$/, '')}${constants.PATH_ADD_SUBMISSION}`,
      visible: true,
    }, {
      label: 'View Submissions',
      path: `${location.pathname.replace(/\/[^/]*$/, '')}${constants.PATH_VIEW_SUBMISSIONS}`,
      visible: true,
    },
  ]

  return (
    <Card
      sx={{
        marginY: 5,
        paddingTop: 5,
        paddingBottom: '300px',
        width: 960,
        '@media (max-width: 960px)': {
          width: '100%',
          margin: '20px 10px 0 10px',
        },
      }}>
      <CardContent>
        {!fbtWebForm?.token ? ( // to safeguard this view if no token is set in state
          <Alert severity="error">
          Invalid token. This FBT Submissions link is invalid or has been expired
          </Alert>
        ) : (
          <Grid container spacing={3}>
            <Grid xs={12} item>
              <Typography
                gutterBottom
                variant="h4"
                align="center"
                sx={{
                  fontWeight: 'bold'
                }}>
                Fringe Benefit Tax
              </Typography>
            </Grid>

            <Grid
              xs={12}
              item
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <CustomTabs tabsConfig={tabsConfig} />
            </Grid>
            <Grid xs={12} item>
              <AddEditFbtRoutes />
            </Grid>

          </Grid>
        )}
      </CardContent>
    </Card>
  )
}

export default Form
